import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../actions/CauHinhGoiTraGop";
import { formatNumber } from "utils/currencyFormat";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactDropdown from "react-dropdown";
import { formatDayMonth } from "utils/formatDate";
import NguonVonApi from "../../../service/nguonVonApi";
export const SearchBarDesktop = ({}) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  const loaiGiaoDich = {
    listGiaoDich: [
      {
        label: "Tất cả",
        value: "",
      },
      {
        label: "Đang sử dụng",
        value: "true",
      },
      {
        label: "Tạm khoá",
        value: "false",
      },
    ],
  };
  // const [loaiGiaoDich, setLoaiGiaoDich] = useState(initGiaoDich.listGiaoDich);

  useEffect(() => {}, []);
  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        iPageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dispatch(getListCauHinhGoiTraGop(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          iPageIndex: 1,
        })
      );
      dispatch(getListCauHinhGoiTraGop(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  return (
    <div className="search-new hidden-mobile-main show-table-main">
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Email</label>
        <input
          type="email"
          className="form-control input-sm "
          id="email-addr"
          placeholder="Tên sản phẩm"
          value={dataSearch.sSearch}
          onChange={updateTextValue("sSearch")}
          onKeyDown={handleKeyDown}
        />
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Trạng thái</label>
        <select
          name="loaigiaodich"
          className="selectBox form-control input-sm"
          value={dataSearch.bStatus}
          onChange={updateDropdown("bStatus")}
        >
          {loaiGiaoDich.listGiaoDich &&
            loaiGiaoDich.listGiaoDich.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>

      <div className="input-sm-new input-new-18 search-main-new">
        <button
          type="submit"
          className="btn btn-info-new btn-seach-ds"
          onClick={onSearch}
        >
          <i className="la la-search"></i>
          <span> &nbsp; Tìm kiếm</span>
        </button>
      </div>
    </div>
  );
};
